import { render, staticRenderFns } from "./ListDetailItem.vue?vue&type=template&id=66a70b28&scoped=true&"
import script from "./ListDetailItem.vue?vue&type=script&lang=js&"
export * from "./ListDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./ListDetailItem.vue?vue&type=style&index=0&id=66a70b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a70b28",
  null
  
)

export default component.exports